import { lazy } from "react";
import { RouterItemType } from "@/app/index";
import { serviceKnowledgeBaseApi } from "@/services/knowledge-base";
import { KnowledgeBaseArticleType } from "@/schemas/index";
import { normalizeArticleNumber } from "../knowledge-base/utils/article-number";

const LayoutPageKnowledgeBaseArticle = lazy(() => import("./layout/index"));

export type LoaderDataKnowledgeBaseArticleType = KnowledgeBaseArticleType;

export const loaderDataKnowledgeBaseArticle = async (args: any) => {
  try {
    const { number } = args.params;

    if (!number) {
      throw new Error("ARTICLE_NOT_FOUND");
    }

    const article = await serviceKnowledgeBaseApi.fetchArticleByNumber(
      normalizeArticleNumber(number),
    );

    if (!article) {
      throw new Error("ARTICLE_NOT_FOUND");
    }

    return article;
  } catch (err) {
    console.error(err);
    throw new Error("ARTICLE_NOT_FOUND");
  }
};

export const routerPageKnowledgeBaseArticle: RouterItemType = {
  path: "/support/kb/:number",
  authorize: false,
  element: <LayoutPageKnowledgeBaseArticle />,
  loader: loaderDataKnowledgeBaseArticle,
};
